const clearFilters = (params: URLSearchParams): URLSearchParams => {
  const newParams = new URLSearchParams();

  // retain keyword search
  newParams.set('filter_search', params.get('filter_search') || '');

  // retain follows
  const follows = params.getAll('follows');
  if (follows?.length > 0) {
    // if there are follows, retain the active filter
    const active = params.get('active');
    if (active) {
      newParams.set('active', active);
    }
    follows.forEach((follow) => newParams.append('follows', follow));
  }

  return newParams;
};

export default clearFilters;
